import React, { useEffect, useState } from "react";
import Table from "../../../Utils/Table/Table1";
import {
  symbolholdoff,
  inrsymbolholdoff,
  updatesymbolstatus,
} from "../../../Services/Admin/Addmin";
import Swal from "sweetalert2";

const Holdoff = () => {
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");

  const [activeSeg, setActiveSeg] = useState("USD");

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [segmentFilter, setSegmentFilter] = useState("");
  const [segmentOptions, setSegmentOptions] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    loadData();
  }, [refresh, search, activeSeg, page, segmentFilter, rowsPerPage]);

  const loadData = async () => {
    try {
      let response;

      if (activeSeg === "INR") {
        response = await inrsymbolholdoff(
          page,
          search,
          segmentFilter,
          rowsPerPage
        );

        const uniqueSegments = [
          ...new Set(response?.data?.map((item) => item.exch_seg)),
        ];
        setSegmentOptions(uniqueSegments);
      } else {
        response = await symbolholdoff(page, search, rowsPerPage);
      }

      setData(response?.data || []);
      setTotalPages(response?.totalPages || 1);
    } catch (err) {
      console.log(err);
    }
  };

  const updatestatus = async (event, symbol) => {
    const user_active_status = event.target.checked ? 1 : 0;

    const dialog = await Swal.fire({
      title: "Do you want to save the changes?",
      showCancelButton: true,
      confirmButtonText: "Save",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
    });

    if (dialog.isConfirmed) {
      try {
        const response = await updatesymbolstatus({
          symbol,
          user_active_status,
        });

        if (response.status) {
          Swal.fire("Saved!", "", "success");
          setRefresh(!refresh);
        }
      } catch {
        Swal.fire("Error", "Something went wrong", "error");
      }
    } else {
      event.target.checked = !event.target.checked;
    }
  };

  const columns = [
    {
      Header: "S.No",
      id: "rowIndex",
      Cell: ({ index }) => (page - 1) * rowsPerPage + index + 1,
    },

    ...(activeSeg === "INR"
      ? [
          {
            Header: "Trade Symbol",
            accessor: "tradesymbol",
          },
        ]
      : []),

    { Header: "Symbol", accessor: "symbol" },
    { Header: "Segment", accessor: "exch_seg" },
    { Header: "Lot Size", accessor: "lotsize" },

    ...(activeSeg === "USD"
      ? [
          {
            Header: "Status",
            accessor: "status",
            Cell: ({ row }) => (
              <label className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={row?.status === 1}
                  onChange={(e) => updatestatus(e, row?.symbol)}
                />
              </label>
            ),
          },
        ]
      : []),
  ];

  return (
    <>
      <div className="container-fluid mt-5 ">
        <div className="card transaction-table custom-bg">
          <div className="card-header border-0 flex-wrap ">
            <h4 className="card-title mb-2">⏸️ Hold Off</h4>

            <div className="btn-group">
              <button
                type="button"
                className={`btn ${
                  activeSeg === "USD" ? "btn-primary" : "btn-outline-primary"
                }`}
                onClick={() => {
                  setActiveSeg("USD");
                  setPage(1);
                }}
              >
                $ USD Wallet
              </button>

              <button
                type="button"
                className={`btn ${
                  activeSeg === "INR" ? "btn-primary" : "btn-outline-primary"
                }`}
                onClick={() => {
                  setActiveSeg("INR");
                  setPage(1);
                }}
              >
                ₹ INR Wallet
              </button>
            </div>
          </div>

          <div className="d-flex align-items-center ms-4 mb-3 gap-4">
            <div>
              <label className="fw-semibold me-2 mt-4">🔍 Search :</label>
              <input
                style={{ width: "250px" }}
                className="form-control d-block"
                type="text"
                placeholder="Search by Symbol / Segment..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setPage(1); // reset page to 1 on search change
                }}
              />
            </div>

            {activeSeg === "INR" && (
              <div>
                <label className="fw-semibold me-2 mt-4">📌 Segment :</label>
                <select
                  style={{ width: "200px" }}
                  className="form-select d-block"
                  value={segmentFilter}
                  onChange={(e) => {
                    setSegmentFilter(e.target.value);
                    setPage(1);
                  }}
                >
                  <option value="">All</option>
                  <option value="NSE">NSE</option>
                  <option value="BSE">BSE</option>
                  <option value="MCX">MCX</option>
                  <option value="CDS">CDS</option>
                </select>
              </div>
            )}
          </div>

          <div className="card-body p-0">
            <Table
              columns={columns}
              data={data}
              page={page}
              totalPages={totalPages}
              onPageChange={(p) => setPage(p)}
              initialRowsPerPage={rowsPerPage}
              onRowsPerPageChange={(newPerPage) => {
                setRowsPerPage(newPerPage);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Holdoff;
